import React, { useState, useEffect } from 'react';
import './Ventas.css';
// CarritoResumen se movió al apartado /carrito
import { useCarrito } from '../context/CarritoContext';
import { useRef } from 'react';
import { getProductColor } from '../utils/colorStore';
import { Link } from 'react-router-dom';
import ensureAbsoluteImg from '../utils/urls';

function Ventas({ usuario }) {
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [productos, setProductos] = useState([]); // cache local
  const [descuento, setDescuento] = useState(0); // porcentaje de descuento seleccionado
  const { carrito, vaciarCarrito } = useCarrito();
  const inputRef = useRef(null);
  
  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(0);
  const scanThreshold = 45; // ms máximo entre caracteres para considerarlo escáner
  const [flash, setFlash] = useState(false);
  const [variantesSeleccionadas, setVariantesSeleccionadas] = useState({}); // { productoId: variantId }
  // auto navegación deshabilitada
  // --- Audio (beep) setup ---
  const audioCtxRef = useRef(null);
  const initAudio = () => {
    if (!audioCtxRef.current) {
      try {
        audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      } catch {
        audioCtxRef.current = null;
      }
    }
  };
  const playBeep = (freq = 880, duration = 120, type = 'sine', volume = 0.3) => {
    const ctx = audioCtxRef.current;
    if (!ctx) return;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = volume;
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration/1000);
  };
  const beepSuccess = () => {
    playBeep(1040, 90, 'square', 0.25);
    setTimeout(()=> playBeep(1560, 90, 'square', 0.20), 95); // doble tono ascendente
  };
  const beepError = () => {
    playBeep(340, 170, 'sawtooth', 0.28);
  };
  const refetchProductos = () => {
    fetch('/api/productos')
      .then(r => r.ok ? r.json() : [])
      .then(data => {
        const norm = Array.isArray(data)? data.map(p => ({ ...p, id: p.id_producto })) : [];
        setProductos(norm);
        setResultados(norm);
      })
      .catch(()=>{});
  };
  const { agregarAlCarrito } = useCarrito();
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setCargando(true);
    fetch('/api/productos')
      .then(r => { if(!r.ok) throw new Error('Error al obtener productos'); return r.json(); })
      .then(data => {
        const norm = Array.isArray(data)? data.map(p => ({ ...p, id: p.id_producto })) : [];
        setProductos(norm); 
        setResultados(norm); 
      })
      .catch(e => { console.error(e); setError(e.message); })
      .finally(()=> setCargando(false));
  }, []);

  const normalizarSerie = (s) => {
    if (s === undefined || s === null) return '';
    try {
      return s.toString().toLowerCase().replace(/\s+/g,'').replace(/[-_]/g,'');
    } catch { return ''; }
  };

  const filtrarLocal = (qRaw) => {
    const q = normalizarSerie(qRaw);
    if(q === '') return productos;
    return productos.filter(p => normalizarSerie(p.codigo).includes(q));
  };

  const handleBuscar = (e) => {
    const valor = e.target.value;
    setBusqueda(valor);
    setResultados(filtrarLocal(valor));
  };

  const buscarExactoBackend = (serie) => {
    const serieLimpia = serie?.trim();
    if(!serieLimpia) { setResultados(productos); return; }
    fetch(`/api/productos/serie/${encodeURIComponent(serieLimpia)}`)
      .then(r => r.ok ? r.json() : null)
  .then(data => setResultados(data ? [{ ...data, id: data.id_producto }] : []))
      .catch(err => console.error('Error búsqueda exacta:', err));
  };

  const handleKeyDown = (e) => {
    if(e.key === 'Enter') {
      buscarExactoBackend(busqueda);
    }
  };

  // Detección global de escáner (ráfaga rápida de teclas)
  useEffect(() => {
    const handler = (e) => {
      // ignorar si el input de búsqueda NO tiene el foco (evita interferir con clicks)
      if (document.activeElement !== inputRef.current) return;
      const now = Date.now();
      if (e.key === 'Enter') {
        const code = scanBuffer.trim();
        if (code.length > 0) {
          setBusqueda(code);
          const normCode = normalizarSerie(code);
          const prod = productos.find(p => normalizarSerie(p.codigo) === normCode);
          if (prod) {
            // agregar al carrito directamente
            if (descuento > 0) {
              const precioOriginal = prod.precio ?? 0;
              const precioDescuento = +(precioOriginal * (1 - descuento/100)).toFixed(2);
              agregarAlCarrito({
                ...prod,
                lineId: `${prod.id}_${descuento}_${Date.now()}`,
                precio: precioDescuento,
                precioOriginal,
                descuentoPorcentaje: descuento,
              });
            } else {
              agregarAlCarrito({ ...prod });
            }
            beepSuccess();
          } else {
            // Fallback: intentar fetch exacto backend y agregar
            fetch(`/api/productos/serie/${encodeURIComponent(code.trim())}`)
              .then(r => r.ok ? r.json() : null)
              .then(data => {
                if (data && data.id_producto) {
                  const prodSrv = { ...data, id: data.id_producto };
                  if (descuento > 0) {
                    const precioOriginal = prodSrv.precio ?? 0;
                    const precioDescuento = +(precioOriginal * (1 - descuento/100)).toFixed(2);
                    agregarAlCarrito({
                      ...prodSrv,
                      lineId: `${prodSrv.id}_${descuento}_${Date.now()}`,
                      precio: precioDescuento,
                      precioOriginal,
                      descuentoPorcentaje: descuento,
                    });
                  } else {
                    agregarAlCarrito(prodSrv);
                  }
                  beepSuccess();
                } else {
                  beepError();
                }
              })
              .catch(() => beepError());
          }
          setScanBuffer('');
          setTimeout(() => setBusqueda(''), 120); // limpiar para siguiente escaneo
          setFlash(true);
          setTimeout(() => setFlash(false), 250);
        }
        return;
      }
      if (e.key.length === 1) { // carácter imprimible
        if (now - lastKeyTime > scanThreshold) {
          setScanBuffer(e.key);
        } else {
          setScanBuffer(prev => prev + e.key);
        }
        setLastKeyTime(now);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [scanBuffer, lastKeyTime]);

  // Enfocar el input bajo demanda (prevent scroll cuando sea posible)
  const focusInput = () => {
    requestAnimationFrame(() => {
      try {
        inputRef.current?.focus({ preventScroll: true });
      } catch (e) {
        // algunos navegadores antiguos no soportan preventScroll
        inputRef.current?.focus();
      }
    });
  };

  // Event listener para beep al confirmar venta
  useEffect(() => {
    const ventaSuccessHandler = () => {
      // asegurar audio inicializado y reproducir doble beep
      initAudio();
      beepSuccess();
    };
    window.addEventListener('venta:success', ventaSuccessHandler);
    return () => window.removeEventListener('venta:success', ventaSuccessHandler);
  }, []);

  const handleEscanear = (codigo) => {
    setBusqueda(codigo);
    buscarExactoBackend(codigo);
  };

  const imprimirTicket = ({ carrito, subtotal, descuento: descTotal, iva, total, metodoPago, recibido, cambio }) => {
    const fecha = new Date();
    const formato = new Intl.DateTimeFormat('es-MX', { dateStyle:'short', timeStyle:'short' }).format(fecha);
    const filas = carrito.map(item => {
      const baseNombre = (item.concepto || item.nombre || '').slice(0,28);
      const nombre = (item.talla && !baseNombre.includes('(' + item.talla + ')')) ? `${baseNombre} (${item.talla})` : baseNombre;
      const cant = item.cantidad;
      const precio = item.precio.toFixed(2);
      const imp = (item.precio * item.cantidad).toFixed(2);
      return `<tr><td>${nombre}</td><td style="text-align:right">${cant}</td><td style="text-align:right">${precio}</td><td style="text-align:right">${imp}</td></tr>`;
    }).join('');
    const ventana = window.open('', '_blank', 'width=400,height=600');
    ventana.document.write(`<!doctype html><html><head><meta charset='utf-8'/><title>Ticket</title>
      <style>
        body { font-family: monospace; font-size:12px; margin:0; padding:10px; }
        h1 { font-size:14px; text-align:center; margin:0 0 8px; }
        table { width:100%; border-collapse:collapse; }
        th,td { padding:2px 0; }
        thead { border-bottom:1px dashed #000; }
        tfoot { border-top:1px dashed #000; }
        .totales td { padding-top:4px; }
        .right { text-align:right; }
      </style></head><body>
      <h1>SAFETYPOINT</h1>
      <div>${formato}</div>
      <table><thead><tr><th style='text-align:left'>Prod</th><th class='right'>Cant</th><th class='right'>P.U.</th><th class='right'>Imp</th></tr></thead>
      <tbody>${filas || '<tr><td colSpan=4>Sin líneas</td></tr>'}</tbody>
      <tfoot class='totales'>
        <tr><td colSpan=3>Subtotal bruto</td><td class='right'>${subtotal.toFixed(2)}</td></tr>
        <tr><td colSpan=3>Descuento</td><td class='right'>-${descTotal.toFixed(2)}</td></tr>
        <tr><td colSpan=3>Subtotal neto</td><td class='right'>${(subtotal-descTotal).toFixed(2)}</td></tr>
        <tr><td colSpan=3><strong>Total</strong></td><td class='right'><strong>${total.toFixed(2)}</strong></td></tr>
        <tr><td colSpan=3>Método</td><td class='right'>${metodoPago}</td></tr>
        ${metodoPago==='efectivo' ? `<tr><td colSpan=3>Recibido</td><td class='right'>${(parseFloat(recibido)||0).toFixed(2)}</td></tr>` : ''}
        ${metodoPago==='efectivo' ? `<tr><td colSpan=3>Cambio</td><td class='right'>${cambio.toFixed(2)}</td></tr>` : ''}
      </tfoot></table>
      <p style='text-align:center'>Gracias por su compra</p>
      <script>setTimeout(()=>window.print(),300)</script>
      </body></html>`);
    ventana.document.close();
  };

  return (
    <div>
      <h2>Ventas</h2>
      <div className="ventas-toolbar">
        <input
          type="text"
          placeholder="Buscar por número de serie (Enter = exacto)"
          value={busqueda}
          onChange={handleBuscar}
          onKeyDown={handleKeyDown}
          ref={inputRef}
          // Nota: no hay autofocus automático; solo inicializamos audio y enfocamos bajo demanda
          onFocus={initAudio}
          onClick={() => { initAudio(); focusInput(); }}
          className={flash ? 'scan-flash' : ''}
        />
        <div className="descuento-group">
          <span className="descuento-group-label">DESCUENTO</span>
          <div className="descuento-pills">
            {[0,5,10,15,20,25,30,40,50].map(d => (
              <button
                key={d}
                type="button"
                onClick={() => setDescuento(d)}
                className={`descuento-pill ${d === descuento ? 'activo' : ''}`}
              >{d}%</button>
            ))}
          </div>
        </div>
        {descuento>0 && (
          <span className="descuento-badge-activo">-{descuento}% activo</span>
        )}
        <Link to="/carrito" className="btn-ir-carrito" style={{marginLeft:'auto'}}>
          🛒 Carrito ({carrito.length})
        </Link>
      </div>
      {cargando && <p>Cargando productos...</p>}
      {error && <p style={{color:'red'}}>Error: {error}</p>}
      <div className="productos-lista">
        {(Array.isArray(resultados) ? resultados : []).map(p => {
          const tieneVariantes = p.variantes && p.variantes.length > 0;
          const varianteSeleccionada = tieneVariantes ? p.variantes.find(v => v.id_variante === variantesSeleccionadas[p.id]) || p.variantes[0] : null;
          
          // Si hay variante seleccionada, usar su precio y stock; sino usar datos del producto base
          const precioBase = Number(varianteSeleccionada?.precio ?? p.precio ?? 0);
          const precioOriginal = precioBase;
          const precioDescuento = descuento>0 ? +(precioOriginal * (1 - descuento/100)).toFixed(2) : precioOriginal;
          const stockDisponible = tieneVariantes ? (varianteSeleccionada?.stock ?? 0) : (p.cantidad ?? 0);
          const imagenUrl = ensureAbsoluteImg(p.imagenes && p.imagenes.length > 0 ? p.imagenes[0].imagen_url : (p.imagen || '/assets/logo-safetypoint.png'));
          
          return (
            <div key={p.id} className="producto-card">
              <img src={imagenUrl} alt={p.concepto} width={100} style={{height:'100px', objectFit:'cover'}} />
              <h4>
                <span style={{display:'inline-flex',alignItems:'center',gap:8}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:8}}>
                    <div style={{width:16,height:16,borderRadius:4,background:getProductColor(p.id) || (p.color || '#ffffff'),border:'1px solid #ccc'}} />
                    {p.concepto}
                  </span>
                </span>
                {p.talla ? <span style={{fontWeight:400,fontSize:'0.9em',color:'#555'}}>( {p.talla} )</span> : null}
              </h4>
              <p>Serie: {p.codigo || '—'}</p>
              
              {/* Mostrar selector de variantes si existen */}
              {tieneVariantes && (
                <div style={{margin:'8px 0'}}>
                  <p style={{fontSize:'12px',margin:'4px 0',fontWeight:600}}>Colores disponibles:</p>
                  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                    {p.variantes.map(v => (
                      <button
                        key={v.id_variante}
                        type="button"
                        onClick={() => setVariantesSeleccionadas(prev => ({ ...prev, [p.id]: v.id_variante }))}
                        title={`${v.color || 'Sin color'} - Stock: ${v.stock}`}
                        style={{
                          width:28,
                          height:28,
                          borderRadius:4,
                          background: v.color || '#f0f0f0',
                          border: varianteSeleccionada?.id_variante === v.id_variante ? '3px solid #0d1846' : '1px solid #ccc',
                          cursor: v.stock > 0 ? 'pointer' : 'not-allowed',
                          opacity: v.stock > 0 ? 1 : 0.4,
                          padding:0
                        }}
                        disabled={v.stock === 0}
                      />
                    ))}
                  </div>
                  {varianteSeleccionada && (
                    <p style={{fontSize:'11px',margin:'4px 0',color:'#555'}}>
                      {varianteSeleccionada.color || 'Color'} - Stock: {varianteSeleccionada.stock}
                      {varianteSeleccionada.talla ? ` - Talla: ${varianteSeleccionada.talla}` : ''}
                    </p>
                  )}
                </div>
              )}
              
              {!tieneVariantes && <p>Talla: {p.talla || '—'}</p>}
              {descuento>0 ? (
                <p>Precio: <span style={{ textDecoration:'line-through', color:'#999' }}>${precioOriginal.toFixed(2)}</span> <strong style={{ color:'#d35400' }}>${precioDescuento.toFixed(2)}</strong></p>
              ) : (
                <p>Precio: ${precioOriginal.toFixed(2)}</p>
              )}
              
              {stockDisponible === 0 && (
                <p style={{color:'#e74c3c',fontSize:'12px',fontWeight:600}}>Sin stock</p>
              )}
              
              <button
                type="button"
                onMouseDown={(e) => { try { e.preventDefault(); } catch(_){} }}
                onTouchStart={(e) => { try { e.preventDefault(); } catch(_){} }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  if (stockDisponible === 0) {
                    alert('Sin stock disponible');
                    return;
                  }
                  
                  const itemBase = { ...p };
                  
                  // Si hay variante seleccionada, incluir datos de variante
                  if (varianteSeleccionada) {
                    itemBase.variant_id = varianteSeleccionada.id_variante;
                    itemBase.variant_sku = varianteSeleccionada.sku;
                    itemBase.variant_color = varianteSeleccionada.color;
                    itemBase.variant_talla = varianteSeleccionada.talla;
                    itemBase.precio = precioBase;
                  }
                  
                  if(descuento>0){
                    agregarAlCarrito({
                      ...itemBase,
                      lineId: `${p.id}_${varianteSeleccionada?.id_variante || 'base'}_${descuento}_${Date.now()}`,
                      precio: precioDescuento,
                      precioOriginal,
                      descuentoPorcentaje: descuento
                    });
                  } else {
                    agregarAlCarrito({ ...itemBase });
                  }
                }}
                className="btn-agregar-carrito"
                disabled={stockDisponible === 0}
                style={{ opacity: stockDisponible === 0 ? 0.5 : 1, cursor: stockDisponible === 0 ? 'not-allowed' : 'pointer' }}
              >
                {descuento>0 ? `Agregar (-${descuento}%)` : 'Agregar al carrito'}
              </button>
            </div>
          );
        })}
      </div>
      {/* Resumen y confirmación de venta ahora viven en /carrito */}
    </div>
  );
}

export default Ventas;
